export default "__VITE_ASSET__x59dUbv7__"